export default class   CambioPasswordRequest {
    constructor(
        public canal: string = "PortalBe"  ,
        public codUsuario?: string  ,
        public valor?: string  ,
        public token?: string  ,
        public newPassword?: string  ,
        public newPasswordRepeat?:string, 
        public valorValidar?:string,
        public origenP2000:boolean=false,
        public idToken?:string

    ){}
}